<template>
  <button
    @click="$emit('click')"
    class="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-[#2600D8] hover:text-blue-800 hover:bg-blue-50 rounded-md transition-colors"
    :class="{ 'bg-blue-50': active }"
  >
    <img :src="CommentIcon" />
    <span>{{ label }}</span>
    <span v-if="commentCount > 0" class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
      {{ commentCount }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { ChatBubbleLeftIcon } from '@heroicons/vue/24/outline';
import CommentIcon from '@/assets/svgs/comment-logo.svg';

interface Props {
  label?: string;
  commentCount?: number;
  active?: boolean;
}

withDefaults(defineProps<Props>(), {
  label: 'Add comment',
  commentCount: 0,
  active: false,
});

defineEmits<{
  click: [];
}>();
</script>
